import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT, UNKNOWN_ENDPOINT } from '@core/const';

@Injectable({
  providedIn: 'root',
})
export class GetMetricsEndpointService {
  // Перечислены эндпоинты которые явно не передаются через контекст
  // и определяются по урлу
  private static externalUrls: [string, RegExp][] = [
    ['cms/components', /^.*\/cms\/components.*$/],
    ['cms/pages', /^.*\/cms\/pages.*$/],
    ['products/search', /^.*\/products\/search.*$/],
    ['products/${productCode}/references', /^.*products\/\d+\/references.*$/],
    ['products/${productCode}', /^.*products\/\d+.*$/],
  ];

  getEndpoint(request: HttpRequest<any>): string {
    const internalEndpoint = request.context.get(HTTP_CONTEXT_ENDPOINT);
    if (internalEndpoint) {
      return internalEndpoint.split('?')[0];
    }

    const externalEndpoint = GetMetricsEndpointService.externalUrls.find((item) => item[1].test(request.url))?.[0];
    if (externalEndpoint) {
      return externalEndpoint;
    }

    return UNKNOWN_ENDPOINT;
  }
}
